/**
 * What patients see as the product's name. «جاباز» is the internal code name only and is never shown;
 * change the shown name here.
 */
export const JABAZ_NAME = 'صف ثبت نوبت';

/** Monthly subscription price (toman). */
export const JABAZ_PRICE_TOMAN = 49_000;

/** Length of one subscription. */
export const JABAZ_SUBSCRIPTION_DAYS = 30;

/** How long a released appointment is held for the patient before it passes to the next person in line. */
export const JABAZ_HOLD_MINUTES = 20;

/** People already waiting before the patient joins, until the service reports the real number. */
export const JABAZ_QUEUE_AHEAD = 12;

/** Same support channel the booking receipt opens. */
export const JABAZ_SUPPORT_URL = 'https://support.paziresh24.com/chats/new?department=3';

export const JABAZ_ROUTES = {
  checkout: '/booking-queue/checkout/',
  receipt: '/booking-queue/receipt/',
  myTurns: '/patient/appointments/',
} as const;

export const faNumber = (value: number) => value.toLocaleString('fa-IR');
/** «۴۹,۰۰۰» — the comma grouping used across the booking pages. */
export const faPrice = (value: number) => value.toLocaleString('fa-IR').replace(/٬/g, ',');
